import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="text-center" data-testid="not-found">
        <p className="font-display text-8xl font-bold text-[#C81D35]">404</p>
        <h1 className="mt-4 font-display text-3xl font-bold text-[#111827]">Page not found</h1>
        <p className="mt-3 text-muted-foreground max-w-md mx-auto">The page you're looking for doesn't exist or may have moved.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Link to="/"><Button className="rounded-full bg-[#C81D35] hover:bg-[#a5162b] gap-2"><Home className="w-4 h-4" /> Back home</Button></Link>
          <Link to="/properties"><Button variant="outline" className="rounded-full">Browse properties</Button></Link>
        </div>
      </div>
    </div>
  );
}
